export const INITIAL_STEP = "INITIAL_STEP";
export const CREATE_STEP = "CREATE_STEP";
export const SUCCESS_STEP = "SUCCESS_STEP";
export const IMG_TYPES = ["image/png", "image/jpeg"];
export const DUPLICATE_CODE = "DuplicateNiche";
